var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../UI/Button';
import { Badge } from '../UI/Badge';
import { Progress } from '../UI/Progress';
import { useToast } from '../UI/Toast';
import { useAuth } from '../../context/AuthContext';
import { TabNavigation } from './tabs/TabNavigation';
import { TabLayout } from './tabs/TabLayout';
import { ResponsiveContainer } from './tabs/ResponsiveContainer';
import { ProgressIndicator } from './tabs/ProgressIndicator';
import { DragDropUpload } from './tabs/DragDropUpload';
import { GuidedTour, useGuidedTour, TAB_TOUR_STEPS } from './tabs/GuidedTour';
import { useTheme, getTabColorScheme, getAnimationClasses } from './tabs/theme-utils';
import UserProfile from '../Auth/UserProfile';
import { pathToPage } from '../../config/routes';
import { cn } from '../../lib/utils';
import { FileText, MessageSquare, Headphones, Network, Layers, Gamepad2, Volume2, Upload, Sparkles, ArrowLeft, HelpCircle } from 'lucide-react';
// Tab Components
import MindMapTabReactFlow from './tabs/MindMapTabReactFlow';
import TTSTab from './tabs/TTSTab';
import { DocumentOverviewTab, AITutorTab, FlashcardsTab, QuizGameTab, PodcastTab, } from './tabs';
// API functions
import { getDocSession, listDocumentsForSession, uploadDocument, listSessionOutputs, listSessionFlashcardSets, listSessionQuizzes, listSessionChats, listSessionPodcasts } from '../../services/apiClient';
import { routes } from '../../config/routes';
var EnhancedDocumentHubV2 = function (_a) {
    var sessionId = _a.sessionId, onBack = _a.onBack;
    var theme = useTheme().theme;
    var currentUser = useAuth().currentUser;
    var navigate = useNavigate();
    var location = useLocation();
    var _b = useState('overview'), activeTab = _b[0], setActiveTab = _b[1];
    var _c = useState(null), sessionData = _c[0], setSessionData = _c[1];
    var _d = useState([]), documents = _d[0], setDocuments = _d[1];
    var _e = useState(false), uploading = _e[0], setUploading = _e[1];
    var _f = useState(false), generating = _f[0], setGenerating = _f[1];
    var _g = useState(0), processingProgress = _g[0], setProcessingProgress = _g[1];
    var _h = useState({}), generatedContent = _h[0], setGeneratedContent = _h[1];
    // New state for enhanced features
    var _j = useState([]), contentProgress = _j[0], setContentProgress = _j[1];
    var _k = useState(false), showDragDrop = _k[0], setShowDragDrop = _k[1];
    var _l = useState(false), isHeaderCollapsed = _l[0], setIsHeaderCollapsed = _l[1];
    var _m = useState(false), isMobile = _m[0], setIsMobile = _m[1];
    var _o = useState(false), showProfile = _o[0], setShowProfile = _o[1];
    var _p = useToast(), showSuccess = _p.showSuccess, showError = _p.showError;
    var fileInputRef = useRef(null);
    // Get current page for navigation
    var currentPage = pathToPage(location.pathname);
    // Navigation handlers
    var handlePageChange = function (page) {
        if (page === 'home')
            navigate('/');
        if (page === 'documents')
            navigate('/documents');
        if (page === 'exam')
            navigate('/exam');
        if (page === 'exam-boards')
            navigate('/exam-boards');
    };
    var handleAuthAction = function (mode) {
        navigate("/".concat(mode));
    };
    // Mobile detection
    useEffect(function () {
        var checkMobile = function () {
            setIsMobile(window.innerWidth < 768);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return function () { return window.removeEventListener('resize', checkMobile); };
    }, []);
    // Guided tour
    var _q = useGuidedTour("document_tabs_".concat(sessionId)), isTourOpen = _q.isOpen, hasTourCompleted = _q.hasCompleted, startTour = _q.startTour, closeTour = _q.closeTour, completeTour = _q.completeTour;
    // Get theme-aware styles
    var colorScheme = getTabColorScheme(theme);
    var animations = getAnimationClasses(theme);
    // Enhanced tab configuration with proper theming and shortcuts
    var tabs = useMemo(function () { return [
        {
            id: 'overview',
            label: 'Overview',
            icon: FileText,
            description: 'Document summary and key insights',
            color: theme === 'dark' ? 'hsl(var(--color-primary))' : '#2563eb',
            shortcut: 'Ctrl+1',
            priority: 1
        },
        {
            id: 'chat',
            label: 'AI Tutor',
            icon: MessageSquare,
            description: 'Interactive learning assistant with personalized help',
            color: theme === 'dark' ? '#8b5cf6' : '#7c3aed',
            badge: 'Smart',
            shortcut: 'Ctrl+2',
            priority: 2
        },
        {
            id: 'flashcards',
            label: 'Flashcards',
            icon: Layers,
            description: 'Study cards for effective memorization',
            color: theme === 'dark' ? 'hsl(var(--color-success))' : '#059669',
            shortcut: 'Ctrl+3',
            priority: 3
        },
        {
            id: 'quiz',
            label: 'Quiz',
            icon: Gamepad2,
            description: 'Interactive knowledge testing and games',
            color: theme === 'dark' ? 'hsl(var(--color-warning))' : '#d97706',
            badge: 'Fun',
            shortcut: 'Ctrl+4',
            priority: 4
        },
        {
            id: 'podcast',
            label: 'Podcast',
            icon: Headphones,
            description: 'Audio learning experience and summaries',
            color: theme === 'dark' ? '#6366f1' : '#4f46e5',
            badge: 'New',
            shortcut: 'Ctrl+5',
            priority: 6
        },
        {
            id: 'mindmap',
            label: 'Mind Map',
            icon: Network,
            description: 'Visual concept connections and relationships',
            color: theme === 'dark' ? '#14b8a6' : '#0d9488',
            shortcut: 'Ctrl+6',
            priority: 5
        },
        {
            id: 'tts',
            label: 'Text-to-Speech',
            icon: Volume2,
            description: 'Convert documents to natural-sounding audio',
            color: theme === 'dark' ? '#f59e0b' : '#d97706',
            badge: 'AI',
            shortcut: 'Ctrl+7',
            priority: 7
        },
        // { 
        //   id: 'definitions', 
        //   label: 'Definitions', 
        //   icon: BookOpen, 
        //   description: 'Key terms and concepts explained',
        //   color: theme === 'dark' ? '#ec4899' : '#db2777',
        //   shortcut: 'Ctrl+7',
        //   priority: 7
        // },
        // { 
        //   id: 'timeline', 
        //   label: 'Timeline', 
        //   icon: Clock, 
        //   description: 'Learning progress and milestone tracking',
        //   color: theme === 'dark' ? 'hsl(var(--color-warning))' : '#d97706',
        //   shortcut: 'Ctrl+8',
        //   priority: 8
        // }
    ]; }, [theme]);
    // Memoize currentUser.uid to prevent unnecessary re-renders
    var currentUserId = useMemo(function () { return currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid; }, [currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid]);
    var memoizedDocuments = useMemo(function () { return documents; }, [documents]);
    var memoizedGeneratedContent = useMemo(function () { return generatedContent; }, [generatedContent]);
    // Start tour automatically for new users
    useEffect(function () {
        if (!hasTourCompleted && documents.length === 0 && !uploading) {
            var timer_1 = setTimeout(function () {
                startTour();
            }, 2000);
            return function () { return clearTimeout(timer_1); };
        }
    }, [hasTourCompleted, documents.length, uploading, startTour]);
    // Load session and document data
    useEffect(function () {
        if (!currentUserId || !sessionId)
            return;
        var loadSessionData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var sessionRes, docsRes, documentList, transformedDocs, _a, flashcardsRes, quizzesRes, chatsRes, podcastsRes, error_1, outputsRes, out, fallbackError_1, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 11, , 12]);
                        return [4 /*yield*/, getDocSession(sessionId)];
                    case 1:
                        sessionRes = _b.sent();
                        setSessionData(sessionRes.session);
                        return [4 /*yield*/, listDocumentsForSession(sessionId)];
                    case 2:
                        docsRes = _b.sent();
                        documentList = docsRes.documents || [];
                        transformedDocs = documentList.map(function (doc) {
                            var _a, _b, _c, _d, _e;
                            return ({
                                id: doc.external_id || doc.id,
                                title: doc.title || doc.filename || 'Untitled Document',
                                type: doc.type || 'PDF',
                                size: doc.size || 0,
                                uploadedAt: doc.created_at || new Date().toISOString(),
                                status: doc.status === 'processed' ? 'ready' : 'processing',
                                analysis: {
                                    keyPoints: ((_a = doc.analysis) === null || _a === void 0 ? void 0 : _a.key_points) || [],
                                    concepts: ((_b = doc.analysis) === null || _b === void 0 ? void 0 : _b.concepts) || [],
                                    difficulty: ((_c = doc.analysis) === null || _c === void 0 ? void 0 : _c.difficulty) || 'intermediate',
                                    estimatedReadTime: ((_d = doc.analysis) === null || _d === void 0 ? void 0 : _d.estimated_read_time) || 10,
                                    wordCount: ((_e = doc.analysis) === null || _e === void 0 ? void 0 : _e.word_count) || 1000
                                }
                            });
                        });
                        setDocuments(transformedDocs);
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 10]);
                        return [4 /*yield*/, Promise.all([
                                listSessionFlashcardSets(sessionId).catch(function () { return ({ flashcard_sets: [] }); }),
                                listSessionQuizzes(sessionId).catch(function () { return ({ quizzes: [] }); }),
                                listSessionChats(sessionId).catch(function () { return ({ chats: [] }); }),
                                listSessionPodcasts(sessionId).catch(function () { return ({ podcasts: [] }); })
                            ])];
                    case 4:
                        _a = _b.sent(), flashcardsRes = _a[0], quizzesRes = _a[1], chatsRes = _a[2], podcastsRes = _a[3];
                        setGeneratedContent({
                            flashcard_sets: (flashcardsRes === null || flashcardsRes === void 0 ? void 0 : flashcardsRes.flashcard_sets) || [],
                            quizzes: (quizzesRes === null || quizzesRes === void 0 ? void 0 : quizzesRes.quizzes) || [],
                            chats: (chatsRes === null || chatsRes === void 0 ? void 0 : chatsRes.chats) || [],
                            podcasts: (podcastsRes === null || podcastsRes === void 0 ? void 0 : podcastsRes.podcasts) || [],
                            mindmap: null,
                            definitions: null,
                            timeline: null
                        });
                        return [3 /*break*/, 10];
                    case 5:
                        error_1 = _b.sent();
                        console.warn('Failed to load some generated content:', error_1);
                        _b.label = 6;
                    case 6:
                        _b.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, listSessionOutputs(sessionId)];
                    case 7:
                        outputsRes = _b.sent();
                        out = (outputsRes === null || outputsRes === void 0 ? void 0 : outputsRes.outputs) || outputsRes || {};
                        setGeneratedContent({
                            flashcards: out.flashcards,
                            quiz: out.quiz,
                            quizzes: out.quizzes,
                            podcast: out.podcast,
                            mindmap: out.mindmap,
                            definitions: out.definitions,
                            timeline: out.timeline,
                            flashcard_sets: out.flashcard_sets
                        });
                        return [3 /*break*/, 9];
                    case 8:
                        fallbackError_1 = _b.sent();
                        console.error('Failed to load content with fallback:', fallbackError_1);
                        return [3 /*break*/, 9];
                    case 9: return [3 /*break*/, 10];
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        error_2 = _b.sent();
                        console.error('Failed to load session data:', error_2);
                        showError('Failed to load session data');
                        return [3 /*break*/, 12];
                    case 12: return [2 /*return*/];
                }
            });
        }); };
        loadSessionData();
    }, [currentUserId, sessionId, showError]);
    // Function to refetch generated content (quizzes and flashcards)
    var refetchGeneratedContent = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, flashcardsRes_1, quizzesRes_1, error_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, Promise.all([
                            listSessionFlashcardSets(sessionId).catch(function () { return ({ flashcard_sets: [] }); }),
                            listSessionQuizzes(sessionId).catch(function () { return ({ quizzes: [] }); })
                        ])];
                case 1:
                    _a = _b.sent(), flashcardsRes_1 = _a[0], quizzesRes_1 = _a[1];
                    setGeneratedContent(function (prev) { return (__assign(__assign({}, prev), { flashcard_sets: (flashcardsRes_1 === null || flashcardsRes_1 === void 0 ? void 0 : flashcardsRes_1.flashcard_sets) || [], quizzes: (quizzesRes_1 === null || quizzesRes_1 === void 0 ? void 0 : quizzesRes_1.quizzes) || [] })); });
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _b.sent();
                    console.warn('Failed to refetch generated content:', error_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [sessionId]);
    // Enhanced file upload with drag-drop support
    var handleDragDropUpload = useCallback(function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var _i, files_1, file, docsRes, documentList, transformedDocs, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setUploading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, 8, 9]);
                    _i = 0, files_1 = files;
                    _a.label = 2;
                case 2:
                    if (!(_i < files_1.length)) return [3 /*break*/, 5];
                    file = files_1[_i];
                    return [4 /*yield*/, uploadDocument(file, sessionId)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    _i++;
                    return [3 /*break*/, 2];
                case 5:
                    showSuccess("".concat(files.length, " file").concat(files.length > 1 ? 's' : '', " uploaded successfully!"));
                    return [4 /*yield*/, listDocumentsForSession(sessionId)];
                case 6:
                    docsRes = _a.sent();
                    documentList = docsRes.documents || [];
                    transformedDocs = documentList.map(function (doc) {
                        var _a, _b, _c, _d, _e;
                        return ({
                            id: doc.external_id || doc.id,
                            title: doc.title || doc.filename || 'Untitled Document',
                            type: doc.type || 'PDF',
                            size: doc.size || 0,
                            uploadedAt: doc.created_at || new Date().toISOString(),
                            status: doc.status === 'processed' ? 'ready' : 'processing',
                            analysis: {
                                keyPoints: ((_a = doc.analysis) === null || _a === void 0 ? void 0 : _a.key_points) || [],
                                concepts: ((_b = doc.analysis) === null || _b === void 0 ? void 0 : _b.concepts) || [],
                                difficulty: ((_c = doc.analysis) === null || _c === void 0 ? void 0 : _c.difficulty) || 'intermediate',
                                estimatedReadTime: ((_d = doc.analysis) === null || _d === void 0 ? void 0 : _d.estimated_read_time) || 10,
                                wordCount: ((_e = doc.analysis) === null || _e === void 0 ? void 0 : _e.word_count) || 1000
                            }
                        });
                    });
                    setDocuments(transformedDocs);
                    return [3 /*break*/, 9];
                case 7:
                    error_4 = _a.sent();
                    console.error('Drag-drop upload failed:', error_4);
                    showError('Failed to upload files');
                    return [3 /*break*/, 9];
                case 8:
                    setUploading(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); }, [sessionId, showSuccess, showError]);
    // Handle regular file upload
    var handleFileUpload = useCallback(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    files = event.target.files;
                    if (!files || files.length === 0)
                        return [2 /*return*/];
                    return [4 /*yield*/, handleDragDropUpload(Array.from(files))];
                case 1:
                    _a.sent();
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [handleDragDropUpload]);
    var handleFileInputClick = useCallback(function () {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }, []);
    // Search and filter handlers
    var handleFilterChange = useCallback(function (filterId, value) {
        // Functionality removed - search bar eliminated
    }, []);
    var handleClearFilters = useCallback(function () {
        // Functionality removed - search bar eliminated
    }, []);
    // Use all documents without filtering since search is removed
    var filteredDocuments = useMemo(function () {
        return memoizedDocuments;
    }, [memoizedDocuments]);
    // Render tab content with enhanced error handling
    var renderTabContent = function () {
        var tabProps = {
            sessionId: sessionId,
            documents: memoizedDocuments,
            sessionData: sessionData,
            generatedContent: memoizedGeneratedContent
        };
        try {
            switch (activeTab) {
                case 'overview':
                    return (_jsx(DocumentOverviewTab, { sessionId: sessionId, documents: memoizedDocuments, sessionData: sessionData, generatedContent: memoizedGeneratedContent, onUpload: handleFileInputClick }));
                case 'chat':
                    return (_jsx(AITutorTab, { sessionId: sessionId, documents: memoizedDocuments }));
                case 'flashcards':
                    return (_jsx(FlashcardsTab, { sessionId: sessionId, documents: memoizedDocuments, preloadedFlashcardSets: memoizedGeneratedContent.flashcard_sets }));
                case 'quiz':
                    return (_jsx(QuizGameTab, { sessionId: sessionId, documents: memoizedDocuments, preloadedQuizzes: memoizedGeneratedContent.quizzes }));
                case 'podcast':
                    return (_jsx(PodcastTab, { sessionId: sessionId, documents: memoizedDocuments }));
                case 'mindmap':
                    return (_jsx(MindMapTabReactFlow, { sessionId: sessionId, documents: memoizedDocuments, sessionData: sessionData, generatedContent: memoizedGeneratedContent, onNavigateToTab: setActiveTab, onRefetchGeneratedContent: refetchGeneratedContent }));
                case 'tts':
                    return (_jsx(TTSTab, { sessionId: sessionId, documents: memoizedDocuments, userId: currentUserId }));
                // case 'definitions':
                //   return (
                //     <DefinitionsTab 
                //       document={memoizedDocuments.find(doc => doc.status === 'ready') || {
                //         id: 'placeholder',
                //         title: 'No Document Available',
                //         type: 'PDF',
                //         size: 0,
                //         uploadedAt: new Date().toISOString(),
                //         status: 'ready' as const
                //       }}
                //     />
                //   );
                // case 'timeline':
                //   return (
                //     <TimelineTab 
                //       document={memoizedDocuments.find(doc => doc.status === 'ready') || {
                //         id: 'placeholder',
                //         title: 'No Document Available',
                //         type: 'PDF',
                //         size: 0,
                //         uploadedAt: new Date().toISOString(),
                //         status: 'ready' as const
                //       }}
                //     />
                //   );
                default:
                    return (_jsx(TabLayout, __assign({ title: "Document Overview", description: "Comprehensive analysis of your uploaded documents", icon: FileText, isEmpty: memoizedDocuments.length === 0, emptyMessage: "Upload documents to start analyzing" }, { children: _jsx(DocumentOverviewTab, { sessionId: sessionId, documents: memoizedDocuments, sessionData: sessionData, onUpload: handleFileInputClick }) })));
            }
        }
        catch (error) {
            console.error('Error rendering tab content:', error);
            return (_jsx(TabLayout, __assign({ title: "Error", description: "Something went wrong", error: "Failed to load tab content. Please try refreshing the page.", onRefresh: function () { return window.location.reload(); } }, { children: _jsx("div", {}) })));
        }
    };
    return (_jsx("div", __assign({ className: cn("h-screen flex transition-colors duration-300 overflow-hidden mobile-content-container", // Added mobile class
        // Use dynamic viewport height on mobile for better browser compatibility
        isMobile && "h-[100dvh] mobile-full-height", theme === 'dark'
            ? 'bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900'
            : 'bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50') }, { children: _jsxs("div", __assign({ className: cn("flex-1 flex flex-col min-h-0 relative overflow-hidden", 
            // Add bottom padding on mobile to account for bottom tab navigation
            isMobile && "pb-20" // Space for bottom tab navigation
            ) }, { children: [_jsx("input", { ref: fileInputRef, type: "file", accept: ".pdf,.doc,.docx,.txt,image/*,audio/*,video/*", onChange: handleFileUpload, className: "hidden", "aria-label": "Upload document" }), !isMobile && (_jsx("div", __assign({ className: "border-b transition-all duration-300 ".concat(theme === 'dark'
                        ? 'bg-background/95 border-border backdrop-blur-sm'
                        : 'bg-background/95 border-border backdrop-blur-sm', " shadow-sm flex-shrink-0 z-30 py-3") }, { children: _jsx("div", __assign({ className: "px-6 w-full overflow-hidden" }, { children: _jsxs("div", __assign({ className: "flex items-center justify-between min-w-0" }, { children: [_jsxs("div", __assign({ className: "flex items-center space-x-3 min-w-0 flex-1" }, { children: [_jsxs(Button, __assign({ variant: "ghost", onClick: function () { return navigate(routes.documents); }, className: "text-muted-foreground hover:text-foreground hover:bg-muted transition-colors" }, { children: [_jsx(ArrowLeft, { className: "w-4 h-4 mr-2" }), "Back to Sessions"] })), _jsxs("div", __assign({ className: "flex items-center space-x-3 min-w-0 flex-1" }, { children: [_jsx("div", __assign({ className: "w-8 h-8 rounded-lg flex items-center justify-center shadow-md flex-shrink-0 bg-gradient-to-r from-blue-500 to-purple-500" }, { children: _jsx(FileText, { className: "w-4 h-4 text-white" }) })), _jsxs("div", __assign({ className: "min-w-0 flex-1" }, { children: [_jsx("h1", __assign({ className: "text-lg font-semibold truncate" }, { children: (sessionData === null || sessionData === void 0 ? void 0 : sessionData.title) || 'Enhanced Learning Session' })), _jsxs("div", __assign({ className: "flex items-center space-x-2 text-sm text-muted-foreground" }, { children: [_jsxs("span", { children: [documents.length, " docs"] }), _jsx("span", { children: "\u2022" }), _jsxs("span", { children: [documents.filter(function (doc) { return doc.status === 'ready'; }).length, " ready"] }), _jsx("span", { children: "\u2022" }), _jsx("span", { children: sessionData ? new Date(sessionData.created_at).toLocaleDateString() : 'Today' }), _jsx(Badge, __assign({ className: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" }, { children: "Active" }))] }))] }))] }))] })), _jsxs("div", __assign({ className: "flex items-center space-x-2 flex-shrink-0" }, { children: [_jsxs(Button, __assign({ variant: "outline", size: "sm", onClick: startTour, "data-tour": "help-button" }, { children: [_jsx(HelpCircle, { className: "w-4 h-4 mr-1" }), "Help"] })), _jsxs(Button, __assign({ variant: "outline", size: "sm", onClick: handleFileInputClick, disabled: uploading, "data-tour": "upload-button" }, { children: [_jsx(Upload, { className: "w-4 h-4 mr-1" }), uploading ? 'Uploading...' : 'Upload'] }))] }))] })) })) }))), isMobile && (_jsx("div", __assign({ className: "bg-background/95 border-b border-border px-4 py-3 flex-shrink-0" }, { children: _jsxs("div", __assign({ className: "flex items-center space-x-3" }, { children: [_jsx("div", __assign({ className: "w-6 h-6 rounded-lg flex items-center justify-center shadow-md flex-shrink-0 bg-gradient-to-r from-blue-500 to-purple-500" }, { children: _jsx(FileText, { className: "w-3 h-3 text-white" }) })), _jsxs("div", __assign({ className: "min-w-0 flex-1" }, { children: [_jsx("h1", __assign({ className: "text-base font-semibold truncate" }, { children: (sessionData === null || sessionData === void 0 ? void 0 : sessionData.title) || 'Enhanced Learning Session' })), _jsxs("div", __assign({ className: "flex items-center space-x-2 text-xs text-muted-foreground" }, { children: [_jsxs("span", { children: [documents.length, " docs"] }), _jsx("span", { children: "\u2022" }), _jsxs("span", { children: [documents.filter(function (doc) { return doc.status === 'ready'; }).length, " ready"] }), _jsx(Badge, __assign({ className: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200 text-xs" }, { children: "Active" }))] }))] })), _jsxs("div", __assign({ className: "flex items-center space-x-1" }, { children: [_jsx(Button, __assign({ variant: "ghost", size: "sm", onClick: startTour, className: "p-2" }, { children: _jsx(HelpCircle, { className: "w-4 h-4" }) })), _jsx(Button, __assign({ variant: "ghost", size: "sm", onClick: handleFileInputClick, disabled: uploading, className: "p-2" }, { children: _jsx(Upload, { className: "w-4 h-4" }) }))] }))] })) }))), !isMobile ? (_jsx("div", __assign({ className: "border-b transition-colors duration-300 ".concat(theme === 'dark'
                        ? 'bg-tab-bar/95 border-tab-bar-border'
                        : 'bg-tab-bar/95 border-tab-bar-border', " backdrop-blur-sm flex-shrink-0 z-20 sticky top-0") }, { children: _jsx(ResponsiveContainer, __assign({ variant: "full-width" }, { children: _jsx(TabNavigation, { tabs: tabs, activeTab: activeTab, onTabChange: setActiveTab, sessionId: sessionId, variant: "default", showLabels: true }) })) }))) : null, documents.some(function (doc) { return doc.status === 'processing'; }) && (_jsx("div", __assign({ className: "border-b transition-colors duration-300 ".concat(theme === 'dark'
                        ? 'bg-info-muted/20 border-info'
                        : 'bg-info-muted border-info/20', " flex-shrink-0 z-10") }, { children: _jsx("div", __assign({ className: "px-3 py-2 w-full" }, { children: _jsxs("div", __assign({ className: "flex items-center space-x-3" }, { children: [_jsxs("div", __assign({ className: "flex-1" }, { children: [_jsxs("div", __assign({ className: "flex items-center space-x-2 mb-1" }, { children: [_jsx(Sparkles, { className: "w-3 h-3 animate-pulse ".concat(theme === 'dark' ? 'text-info' : 'text-info') }), _jsx("span", __assign({ className: "text-xs font-medium ".concat(theme === 'dark' ? 'text-info' : 'text-info') }, { children: "Processing Documents..." }))] })), _jsx(Progress, { value: processingProgress, className: "h-1.5" })] })), _jsxs("span", __assign({ className: "text-xs font-medium ".concat(theme === 'dark' ? 'text-info' : 'text-info') }, { children: [processingProgress, "%"] }))] })) })) }))), _jsx("div", __assign({ className: cn("flex-1 relative w-full min-w-0", // Added w-full and min-w-0 to prevent overflow
                    activeTab === 'mindmap' ? 'overflow-hidden' : 'overflow-y-auto overflow-x-hidden', // Explicitly hide horizontal scroll
                    isMobile && 'min-h-0', 
                    // Ensure smooth scrolling on mobile
                    isMobile && 'touch-pan-y overscroll-behavior-y-contain') }, { children: _jsxs(ResponsiveContainer, __assign({ variant: activeTab === 'mindmap' ? 'full-width' : 'default', enableMobileTabs: true, className: cn(activeTab === 'mindmap' ? 'h-full' : ''
                        // Remove mobile padding since it's handled by the main container
                        ) }, { children: [contentProgress.length > 0 && activeTab !== 'mindmap' && (_jsx("div", __assign({ className: "mb-6", "data-tour": "progress-indicator" }, { children: _jsx(ProgressIndicator, { progress: contentProgress }) }))), documents.length === 0 && activeTab !== 'mindmap' && (_jsx("div", __assign({ className: "mb-6" }, { children: _jsx(DragDropUpload, { onFilesUpload: handleDragDropUpload, disabled: uploading, className: "max-w-2xl mx-auto" }) }))), _jsx("div", __assign({ className: "".concat(animations.fadeIn, " ").concat(activeTab === 'mindmap' ? 'h-full' : '') }, { children: renderTabContent() }))] })) })), _jsx(GuidedTour, { steps: TAB_TOUR_STEPS, isOpen: isTourOpen, onClose: closeTour, onComplete: completeTour }), currentUser && (_jsx(UserProfile, { isOpen: showProfile, onClose: function () { return setShowProfile(false); } })), isMobile && (_jsx("div", __assign({ className: cn("fixed bottom-0 left-0 right-0 z-[55]", // Ensure it's above content but below sidebar
                    "border-t transition-all duration-300", "shadow-lg", // Enhanced shadow for better separation
                    theme === 'dark'
                        ? 'bg-tab-bar/98 border-tab-bar-border mobile-navbar-backdrop'
                        : 'bg-tab-bar/98 border-tab-bar-border mobile-navbar-backdrop', "backdrop-blur-md", // Enhanced backdrop blur
                    "navbar-bottom ios-navbar-fix", "min-h-[64px]" // Optimized minimum height for better touch targets
                    ) }, { children: _jsxs("div", __assign({ className: "px-1 py-1" }, { children: [" ", _jsx(TabNavigation, { tabs: tabs, activeTab: activeTab, onTabChange: setActiveTab, sessionId: sessionId, variant: "mobile", showLabels: true, className: "px-1 py-1" // Minimal internal padding for maximum space
                             })] })) })))] })) })));
};
export default EnhancedDocumentHubV2;
